import Button from "./GroupButton";
import GroupPanel from "./GroupPanel";

export default {
    button: Button,
    name: "group",
    panel: GroupPanel,
    panelClass: "group-panel",
};
